import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import LoaderGradient from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

export const TechnologiesFiltersLoader = () => {
    return (
        <Box>
            <Flex
                alignItems="center"
                justifyContent="flex-start"
                gap="32px"
                borderBottom={`1px solid ${colorsPalettes.carbon["100"]}`}
                padding="16px 24px"
            >
                {Array.from({ length: 3 }).map((_, index) => (
                    <LoaderGradient
                        key={index}
                        height={32}
                        width={152}
                    />
                ))}
            </Flex>
            <Flex
                padding="14px 24px"
                borderBottom={`1px solid ${colorsPalettes.carbon["100"]}`}
            >
                <LoaderGradient height={36} />
            </Flex>
        </Box>
    );
};
